import axios from 'axios';
import { WebshopCategory, WebshopProduct } from '@/services/models';
import { toCamelCaseProperties } from '@/utils/fn';
const service = axios.create({
	baseURL: '/api/ajax/Webshop/'
});

export default {
	/**
	 * Gets webshop categories
	 * @returns {Promise<WebshopSetting[]|boolean>} Array of Webshop settings, or `false` if fetching failed.
	 */
	async GetWebshopSettings(params) {
		return await axios.get('/api/ajax/Webshop/GetWebshopSettings', params);
	},

	/**
	 * Gets webshop categories
	 * @returns {Promise<WebshopCategory[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetCategories(params) {
		return await axios.get('/api/ajax/Webshop/GetWebshopCategories', params);
	},

	/**
	 * Get the products for site or chain
	 * @returns {Promise<WebshopProduct[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetProducts(params) {
		return await axios.post('/api/ajax/Webshop/GetWebshopBasicProducts', params);
	},

	/**
	 * Get the products for site or chain by list of ids
	 * @returns {Promise<WebshopProduct[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetProductsByIds(params) {
		return await axios.post('/api/ajax/Webshop/GetWebshopBasicProductsById', params);
	},

	/**
	 * Get webshop bundles specified by ids
	 * @returns {Promise<WebshopProduct[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetWebshopBundlesByIds(params) {
		return await axios.post('/api/ajax/Webshop/GetWebshopBundlesByIds', params);
	},

	/**
	 * 
	 * Fetch discounts for a product
	 */
	async GetDiscountsByProductId (params) {
		return await axios.post('/api/ajax/Webshop/GetWebshopProductDiscounts', params)
	},

	/**
	 * Get the products for site or chain by list of ids
	 * @returns {Promise<WebshopProduct[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetCampaignProducts(params) {
		return await axios.post('/api/ajax/Webshop/GetWebshopBasicProductsByIds', params);
	},

	/**
	 * Get the similar products for chain by categoryId
	 * @returns {Promise<WebshopProduct[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetSimiliarProductsByCategoryId(params) {
		return await axios.post('/api/ajax/Webshop/GetSimiliarProductsByCategoryId', params);
	},

	/**
	 * Get the products for chain by search text
	 * @returns {Promise<WebshopProduct[]|boolean>} Array of Webshop products, or `false` if fetching failed.
	 */
	async GetProductsBySearchText(params) {
		return await axios.post('/api/ajax/Webshop/GetProductsBySearchText', params);
	},

	/**
	 * Get the products for site or chain
	 * @returns {Promise<WebshopProductDetail[]|boolean>} Array of Webshop products with details, or `false` if fetching failed.
	 */
	async GetProductsDetails(params) {
		return await axios.post('/api/ajax/Webshop/GetWebshopDetailedProducts', params);
	},

	async ProcessOrderCheckout(params) {
		return await axios.post('/api/ajax/Webshop/ProcessOrderCheckout', params);
	},

	/**
	 * Get the status of the action
	 * @returns {Promise<boolean>} Array of webshop categories, or `false` if fetching failed.
	 */
	async ReserveProductsForClickAndCollect(){
		return true;
	},
	/**
	 * Get the shopping cart for the currently logged in user
	 * @returns {Promise<UserBehavior[]|boolean>} Array of user behaviors, or `false` if fetching failed.
	 */
	async GetShoppingCartItems(params){
		return await axios.post('/api/ajax/Webshop/GetShoppingCartItems', params);
	},
	/**
	 * Get popular products for provided chain or site id
	 *  @returns {Promise<WebshopProduct[]|boolean>} Array of webshop products, or `false` if fetching failed.
	 */
	async GetPopularProducts(params){
		return await axios.post('/api/ajax/Webshop/GetPopularProducts', params);
	},

	async GetPaymentMethodsConfig() {
		return await axios.get(process.env.VUE_APP_FIXIT_NO_BOOKING_URL +'/api/Payment/payment-methods')
	},
};
